import { render, staticRenderFns } from "./EventSlogan.vue?vue&type=template&id=4db5634e&"
import script from "./EventSlogan.vue?vue&type=script&lang=js&"
export * from "./EventSlogan.vue?vue&type=script&lang=js&"
import style0 from "./EventSlogan.vue?vue&type=style&index=0&id=4db5634e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports